import { toast } from 'react-toastify';
import Api from '../lib/api/api';

export const SOMETHING_WENT_WRONG = 'Something went wrong';
export const getUsers = (token, pagination, companyType, role, getDeleted, permissionsGroup = 'all') => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_USERS',
  });
  try {
    const users = await api.users.getUsers(pagination, companyType, role, getDeleted, permissionsGroup);
    dispatch({
      type: 'GET_USERS_SUCCESS',
      users,
    });
  } catch (error) {
    const { message } = error;
    dispatch({
      type: 'GET_USERS_FAILURE',
      error,
    });
    toast.error(message || 'Error in fetching users.', { toastId: 'GET_USERS_FAILURE' });
  }
};

export const getUsersByCompanyId = (token, id, pagination, disablePaginate) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_USERS_BY_COMPANY',
  });
  try {
    const users = await api.users.getUsersByCompanyId(id, pagination, disablePaginate);
    dispatch({
      type: 'GET_USERS_BY_COMPANY_SUCCESS',
      users,
    });
    return users;
  } catch (error) {
    const { message } = error;
    dispatch({
      type: 'GET_USERS_BY_COMPANY_FAILURE',
      error,
    });
    toast.error(message || 'Error in fetching users.', { toastId: 'GET_USERS_BY_COMPANY_FAILURE' });
  }
};

export const getUsersRequests = (token) => async dispatch => {
  const api = new Api(token);
  try {
    const users = await api.users.getUsersRequests();
    dispatch({
      type: 'GET_USERS_REQUESTS_SUCCESS',
      users,
    });
    return users;
  } catch (error) {
    const { message } = error;
    dispatch({
      type: 'GET_USERS_REQUESTS_FAILURE',
      error,
    });
    toast.error(message || 'Error in fetching users.', { toastId: 'GET_USERS_REQUESTS_FAILURE' });
  }
};

export const updateUserRequest = (token, body) => async dispatch => {
  const api = new Api(token);
  try {
    const users = await api.users.updateUserRequest([body]);
    dispatch({
      type: 'UPDATE_USER_REQUEST_SUCCESS',
      users,
    });
    return users;
  } catch (error) {
    const { message } = error;
    dispatch({
      type: 'UPDATE_USER_REQUEST_FAILURE',
      error,
    });
    toast.error(error?.response?.data || message || 'Error in fetching users.', { toastId: 'UPDATE_USER_REQUEST_FAILURE' });
  }
};

export const filterByEmail = (
  token,
  id,
  email,
  pagination,
  disablePaginate,
  role,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_USERS',
  });
  try {
    const users = await api.users.filterByEmail(id, email, pagination, disablePaginate, role);
    dispatch({
      type: 'GET_USERS_SUCCESS',
      users,
    });
    return users;
  } catch (error) {
    dispatch({
      type: 'GET_USERS_FAILURE',
      error,
    });
    // toast.error(message || 'Error in fetching users.', { toastId: 'GET_USERS_BY_COMPANY_FAILURE' });
  }
};

export const filterByName = (
  token,
  id,
  name,
  pagination,
  disablePaginate,
  role,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_USERS',
  });
  try {
    const users = await api.users.filterByName(id, name, pagination, disablePaginate, role);
    dispatch({
      type: 'GET_USERS_SUCCESS',
      users,
    });
    return users;
  } catch (error) {
    dispatch({
      type: 'GET_USERS_FAILURE',
      error,
    });
    // toast.error(message || 'Error in fetching users.', { toastId: 'GET_USERS_BY_COMPANY_FAILURE' });
  }
};

export const filterByCompany = (
  token,
  id,
  pagination,
  disablePaginate,
  userType,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_USERS',
  });
  try {
    const users = await api.users.filterByCompany(id, pagination, disablePaginate, userType);
    dispatch({
      type: 'GET_USERS_SUCCESS',
      users,
    });
    return users;
  } catch (error) {
    dispatch({
      type: 'GET_USERS_FAILURE',
      error,
    });
    // toast.error(message || 'Error in fetching users.', { toastId: 'GET_USERS_BY_COMPANY_FAILURE' });
  }
};

export const onRecover = (token, userID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_USER',
  });
  try {
    await api.users.onRecover(userID);
    dispatch({
      type: 'RECOVER_USER_SUCCESS',
    });
    toast.success('User Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_USER_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in recovering user`);
  }
};

export const addUser = (token, companyId, user) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'ADD_USER',
    user,
  });
  try {
    const addedUser = await api.users.addUser(companyId, user);
    dispatch({
      type: 'ADD_USER_SUCCESS',
      user: addedUser,
    });
    dispatch({
      type: 'ADD_USER_RESET',
    });
    toast.success('New user added!', { toastId: 'GET_USERS_SUCCESS' });
    return addedUser;
  } catch (error) {
    dispatch({
      type: 'ADD_USER_FAILURE',
      error,
    });
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
  }
};

// add bulk users
export const addBulkUser = (token, usersCSV) => async dispatch => {
  const api = new Api(token);
  try {
    await api.users.addBulkUser(usersCSV);
    toast.success('New users added!');
    return true;
  } catch (error) {
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
    return false;
  }
};

// Add User dialog UI actions
export const showAddUser = id => dispatch => {
  dispatch({
    type: 'ADD_USER_SHOW',
    id,
  });
  dispatch({
    type: 'ADD_USER_COMPANY_FILTER',
    filter: {},
  });
};

export const cancelAddUser = () => dispatch => {
  dispatch({
    type: 'ADD_USER_CANCEL',
  });
  dispatch({
    type: 'ADD_USER_RESET',
  });
};

export const addUserChange = userData => dispatch => {
  dispatch({
    type: 'ADD_USER_CHANGE',
    name: userData.name,
    value: userData.value,
  });
};

export const deleteUser = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_USER',
    id,
  });
  try {
    const deletedUser = await api.users.deleteUser(id);
    dispatch({
      type: 'DELETE_USER_SUCCESS',
      deletedUser,
    });
    toast.success('User deleted!', { toastId: 'DELETE_USER_SUCCESS' });
    return deletedUser;
  } catch (error) {
    const errorMessage = error.response.data.error || error;
    dispatch({
      type: 'DELETE_USER_FAILURE',
      error: errorMessage
    });
    toast.error(error.response.data.error || SOMETHING_WENT_WRONG);
    return false;
  }
};

export const setUserStatus = (token, id, status, type) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'SET_USER_STATUS',
    status,
    id,
  });
  try {
    const changedUser = await api.users.setUserStatus(id, status, type);
    if (type === '2FA' && status) {
      toast.success('2FA code sent to your email');
    }
    dispatch({
      type: 'SET_USER_STATUS_SUCCESS',
      changedUser,
    });
    return changedUser;
  } catch (error) {
    if (type === '2FA') {
      toast.error((error.response && error.response.data && error.response.data.error) || (error.response && error.response.data) || SOMETHING_WENT_WRONG);
    }
    dispatch({
      type: 'SET_USER_STATUS_FAILURE',
      error,
    });
  }
};

// Delete User dialog UI actions
export const showDeleteUser = id => dispatch => {
  dispatch({
    type: 'DELETE_USER_SHOW',
    id,
  });
};
// Delete User dialog UI actions
export const masterBoxPressCall = status => dispatch => {
  dispatch({
    type: 'MASTER_BOX_PRESS_SUCCESS',
    status,
  });
};

export const cancelDeleteUser = () => dispatch => {
  dispatch({
    type: 'DELETE_USER_CANCEL',
  });
};

export const addUserCompanyFilter = filter => dispatch => {
  dispatch({
    type: 'ADD_USER_COMPANY_FILTER',
    filter,
  });
};

export const updateUserById = (token, id, userObj) => async dispatch => {
  const api = new Api(token);

  dispatch({
    type: 'UPDATE_USER_BY_ID',
  });

  try {
    const res = await api.users.updateUserById(id, userObj);
    dispatch({
      type: 'UPDATE_USER_BY_ID_SUCCESS',
      user: res,
    });
    toast.success('User updated!', { toastId: 'UPDATE_USER_BY_ID_SUCCESS' });
    return res;
  } catch (error) {
    dispatch({
      type: 'UPDATE_USER_BY_ID_FAILURE',
    });
    let errorMessage = error.response.data || SOMETHING_WENT_WRONG;
    // eslint-disable-next-line no-prototype-builtins
    if (error.response.data.hasOwnProperty('error')) {
      errorMessage = error.response.data.error;
    }
    toast.error(errorMessage);
  }
};

export const resetPasswordByOld = (
  token,
  userId,
  oldPassword = '',
  newPassword = '',
  isAutoGenerate,
  godMode,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RESET_PASSWORD_BY_ID',
  });

  try {
    const res = await api.users.resetPasswordByOld(userId, oldPassword, newPassword, isAutoGenerate, godMode);
    dispatch({
      type: 'RESET_PASSWORD_BY_ID_SUCCESS',
    });
    toast.success('Password updated!', { toastId: 'RESET_PASSWORD_BY_ID_SUCCESS' });
    return res;
  } catch (error) {
    dispatch({
      type: 'RESET_PASSWORD_BY_ID_FAILURE',
    });
    toast.error(`${error.response.data}`, { toastId: 'UPDATE_PASSWORD_BY_ID_FAILURE' });
    throw new Error();
  }
};

export const showUpdateUser = () => dispatch => {
  dispatch({
    type: 'UPDATE_USER_SHOW',
  });
};

export const closeUpdateUser = () => dispatch => {
  dispatch({
    type: 'UPDATE_USER_CANCEL',
  });
  dispatch({
    type: 'ADD_USER_COMPANY_FILTER',
    filter: {},
  });
};

export const changeFieldUpdateUser = (name, value) => dispatch => {
  dispatch({
    type: 'UPDATE_USER_CHANGE_FIELD',
    name,
    value,
  });
};

export const initialUpdateUserData = userObj => dispatch => {
  dispatch({
    type: 'UPDATE_USER_INITIAL_DATA',
    userObj,
  });
};

export const sendResetMail = email => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'SEND_RESET_EMAIL',
  });
  try {
    const res = await api.users.sendResetMail(email);
    dispatch({
      type: 'SEND_RESET_EMAIL_SUCCESS',
      email,
    });
    toast.success('Email sent!', { toastId: 'SEND_RESET_EMAIL_SUCCESS' });
    return res;
  } catch (error) {
    dispatch({
      type: 'SEND_RESET_EMAIL_FAILURE',
    });
    const errorMessage =
      error?.response?.data ||
      "Password reset isn’t available for this login. Please contact your Granite account manager for access.";
    if (
      errorMessage ===
      "Password reset isn’t available for this login. Please contact your Granite account manager for access."
    ) {
      toast.error(errorMessage, { toastId: 'SEND_RESET_EMAIL_FAILURE' });
    } 
    else if (
      errorMessage ===
      "We have already sent a reset password email to your address. Please check your email for the reset instructions or wait for two minutes to request a new reset link."
    ) {
      toast.error(errorMessage, { toastId: 'SEND_RESET_EMAIL_FAILURE' });
    }else {
      toast.success('Email sent!', { toastId: 'SEND_RESET_EMAIL_SUCCESS' });
    }

    throw new Error(errorMessage);
  }
};

export const resetPassword = (email, password, link) => async dispatch => {
  const api = new Api();
  dispatch({
    type: 'RESET_PASSWORD',
  });
  try {
    const res = await api.users.resetPassword(email, password, link);
    dispatch({
      type: 'RESET_PASSWORD_SUCCESS',
    });
    toast.success('Password updated!', { toastId: 'RESET_PASSWORD_SUCCESS' });
    console.log('res',res);
    
    return res;
  } catch (error) {
    dispatch({
      type: 'RESET_PASSWORD_FAILURE',
    });
    // toast.error(`${error.response.data}`, { toastId: 'RESET_PASSWORD_FAILURE' });
    // throw new Error(error);
     throw error; // Re-throw the error to be caught in the component
  }
};

export const getUserPermissions = (token, userID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_USER_PERMISSIONS',
  });

  try {
    const result = await api.users.getUserPermissions(userID);
    dispatch({
      type: 'GET_USER_PERMISSIONS_SUCCESS',
    });
    return result;
  } catch (error) {
    dispatch({
      type: 'GET_USER_PERMISSIONS_ERROR',
    });
    toast.error(`Something went wrong`, { toastId: 'GET_USER_PERMISSIONS_ERROR' });
    throw new Error(error);
  }
};

export const userResetPassword = (token, body) => async dispatch => {
  const api = new Api(token);
  try {
    const result = await api.users.userResetPassword(body);
    dispatch({
      type: 'RESET_USER_PASSWORD_STATUS',
    });
    toast.success('Password updated successfully!');
    return result;
  } catch (error) {
    dispatch({
      type: 'RESET_USER_PASSWORD_ERROR',
    });
    toast.error(error.response.data || SOMETHING_WENT_WRONG);
    throw new Error(error);
  }
};

export const userLoginPasswordResetOnLogin = (token, resetValue) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'USER_LOGIN_PASSWORD_RESET',
  });
  try {
    const data = await api.users.userLoginPasswordResetOnLogin(resetValue);
    dispatch({
      type: 'USER_LOGIN_PASSWORD_RESET_SUCCESS',
    });
    return data;
  } catch (error) {
    const message = error.response.data.error;
    toast.error(message || 'Error resetting Password. Please try again', {
      toastId: 'USER_LOGIN_PASSWORD_RESET_FAILURE',
    });
  }
}

export const getEnterpriseGroupUser = (token, enterpriseGroupID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_ENTERPRISE_GROUP_USERS',
  });
  try {
    const data = await api.users.getEnterpriseGroupUser(enterpriseGroupID);
    dispatch({
      type: 'ENTERPRISE_GROUP_USERS_SUCCESS',
    });
    return data;
  } catch (error) {
    const message = error.response.data.error;
    toast.error(message || 'Error getting enterprise users', {
      toastId: 'USER_LOGIN_PASSWORD_RESET_FAILURE',
    });
  }
};

export const getUserAccountLock = (token, userID) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_USER_ACCOUNT_LOCK_STATUS',
  });

  try {
    const result = await api.users.getUserAccountLock(userID);
    dispatch({
      type: 'GET_USER_ACCOUNT_LOCK_STATUS_SUCCESS',
    });
    return result;
  } catch (error) {
    dispatch({
      type: 'GET_USER_ACCOUNT_LOCK_STATUS_ERROR',
    });
    toast.error(`Something went wrong`, { toastId: 'GET_USER_ACCOUNT_LOCK_STATUS_ERROR' });
    throw new Error(error);
  }
};
export const setCookies = (token) => async dispatch => {

  const api = new Api(token);
  dispatch({
    type: 'SET_COOKIES',
  });

  try {
    const result = await api.users.setCookie();
    dispatch({
      type: 'SET_COOKIES_SUCCESS',
    });
    return result;
  } catch (error) {

    dispatch({
      type: 'SET_COOKIES_ERROR',
    });
    toast.error(`Something went wrong`, { toastId: 'SET_COOKIES_ERROR' });
  }
};

export const setIntervalId = (interval) => async dispatch => {
  dispatch({
    type: 'SET_INTERVAL',
    payload: interval
  });
};
export const getUsersOobm = (token, pagination) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_USERS',
  });
  try {
    const users = await api.users.getUsersOobm(pagination);
    dispatch({
      type: 'GET_OOBM_USERS_SUCCESS',
    });
    return users
  } catch (error) {
    const { message } = error;
    dispatch({
      type: 'GET_OOBM_USERS_FAILURE',
      error,
    });
    toast.error(message || 'Error in fetching users.', { toastId: 'GET_OOBM_USERS_FAILURE' });
  }
};
export const assignUsersOobm = (token, assignment) => async dispatch => {
  const api = new Api(token);
  dispatch({ type: 'ASSIGN_USER' });
  try {
    await api.users.assignUsersOobm(assignment);
    dispatch({ type: 'ASSIGN_USER_SUCCESS' });
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.error || 'Error, Please try again';
    toast.error(message, { toastId: 'ASSIGN_USER_FAILURE' });

    return { success: false };
  }
};
export const getUserOobm = (token, userId) => async dispatch => {
  const api = new Api(token);
  dispatch({ type: 'ASSIGN_USER' });
  try {
    const data = await api.users.getUserOobm(userId);
    dispatch({ type: 'ASSIGN_USER_SUCCESS' });
    return data
  } catch (error) {
    const message = error.response?.data?.error || 'Error, Please try again';
    toast.error(message, { toastId: 'ASSIGN_USER_FAILURE' });

    return { success: false };
  }
};
export const getOobmDeviceEnabled = (token,userId) => async dispatch => {
  const api = new Api(token);
  dispatch({ type: 'GET_OOBM_ENABLED_REQUEST' });
  try {
    const data = await api.users.getOobmDeviceEnabled(userId);
    dispatch({ type: 'GET_OOBM_ENABLED_SUCCESS', payload: data });
    return data;
  } catch (error) {
    const message = error?.response?.data?.error || 'Error, Please try again';
    dispatch({ type: 'GET_OOBM_ENABLED_FAILURE', error: message });
    toast.error(message, { toastId: 'GET_OOBM_ENABLED_FAILURE' });
    return { success: false };
  }
};